function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "change-catalog",
  transform: "translate(-2.25 -2.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11803",
  "data-name": "Path 11803",
  d: "M29.453,27.491v2.741h3.371a8.14,8.14,0,0,1-6.112,2.741,8.231,8.231,0,0,1-8.222-8.222H15.75a10.94,10.94,0,0,0,19.184,7.214v3.748h2.741V27.491Z",
  transform: "translate(2.943 4.905)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11804",
  "data-name": "Path 11804",
  d: "M26.712,15.75A11.017,11.017,0,0,0,18.491,19.5V15.75H15.75v8.222h8.222V21.231H20.6a8.14,8.14,0,0,1,6.112-2.741,8.231,8.231,0,0,1,8.222,8.222h2.741A10.975,10.975,0,0,0,26.712,15.75Z",
  transform: "translate(2.943 2.943)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11805",
  "data-name": "Path 11805",
  d: "M15.953,37.877H7.731V32.4h2.741V29.655H7.731V22.8h2.741V20.063H7.731V13.212h2.741V10.472H7.731V4.991H32.4V15.953h2.741V4.991A2.741,2.741,0,0,0,32.4,2.25H7.731A2.741,2.741,0,0,0,4.991,4.991v5.481H2.25v2.741H4.991v6.851H2.25V22.8H4.991v6.851H2.25V32.4H4.991v5.481a2.741,2.741,0,0,0,2.741,2.741h8.222Z",
  fill: "#ac1ede"
}));

var SvgChangeCatalog = function SvgChangeCatalog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38.367,
    height: 38.368,
    viewBox: "0 0 38.367 38.368",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChangeCatalog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/change-catalog.0079b314.svg";
export { ForwardRef as ReactComponent };